import { FC } from 'react';
import { IEventOrganizer } from '../types';


export const EventOrganizer: FC<IEventOrganizer> = ({ contactsData }) => {
  return (
    <div className="flex flex-col mx-6 mb-6 gap-4">
    <h3 className="text-2xl lg:text-3xl font-bold">{contactsData.eventOrganizer.name}</h3>
      <div className="flex flex-col mx-6 mb-6">
        <div className="mb-3">         
          <p className="font-semibold text-xl">{contactsData.eventOrganizer.subject}</p>
          <p className="font-semibold mb-3">{contactsData.eventOrganizer.subjectForm}</p>
          <p>{contactsData.eventOrganizer.registrationDetail}</p>
          <p>{contactsData.eventOrganizer.registrationNumber.name}: {contactsData.eventOrganizer.registrationNumber.value}</p>
          <p>{contactsData.eventOrganizer.dataBox.name}: {contactsData.eventOrganizer.dataBox.value}</p>
        </div>
        <div className="mb-3">
          <p>{contactsData.eventOrganizer.address.name}: {contactsData.eventOrganizer.address.street}, {contactsData.eventOrganizer.address.partOfCity}</p>
          <p>{contactsData.eventOrganizer.address.postCode} {contactsData.eventOrganizer.address.city}</p>
          <p>{contactsData.eventOrganizer.email.name}: {contactsData.eventOrganizer.email.value}</p>
          <p>{contactsData.eventOrganizer.secretariatPhoneNumber.name}: {contactsData.eventOrganizer.secretariatPhoneNumber.value}</p>
        </div>
        <p>{contactsData.eventOrganizer.bankDetails.bankAccount.name}: {contactsData.eventOrganizer.bankDetails.bankAccount.value}</p>
        <p>{contactsData.eventOrganizer.bankDetails.IBAN.name}: {contactsData.eventOrganizer.bankDetails.IBAN.value}</p>
        <p>{contactsData.eventOrganizer.bankDetails.SWIFT.name}: {contactsData.eventOrganizer.bankDetails.SWIFT.value}</p>
      </div>
    </div>
  )
}